<template>
  <div class="expert-profile">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link" style="color: #3498db;">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span class="separator">></span>
        <router-link to="/expert-team">专家团队</router-link>
        <span class="separator">></span>
        <span class="current">{{ expert ? expert.name : '专家详情' }}</span>
      </div>
    </div>

    <!-- 专家详情内容 -->
    <div class="expert-detail-content" v-if="expert">
      <div class="container">
        <!-- 专家基本信息 -->
        <section class="expert-header">
          <div class="expert-avatar-large">
            <div class="avatar-circle">{{ expert.avatar }}</div>
          </div>
          <div class="expert-basic-info">
            <h1>{{ expert.name }}</h1>
            <p class="expert-title">{{ expert.title }}</p>
            <p class="expert-specialty">{{ expert.specialty }}</p>
            <div class="expert-tags">
              <span class="tag" v-for="tag in expert.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
          <div class="expert-actions">
            <button @click="openShowBookingForm()" class="btn-primary">预约咨询</button>
            <button @click="shareProfile" class="btn-secondary">分享</button>
          </div>
        </section>

        <!-- 专家简介 -->
        <section class="expert-intro">
          <h2>专家简介</h2>
          <div class="intro-content">
            <p>{{ expert.bio }}</p>
          </div>
        </section>

        <!-- 主要成就 -->
        <section class="expert-achievements">
          <h2>主要成就</h2>
          <div class="achievements-list">
            <div class="achievement-item" v-for="achievement in expert.achievements" :key="achievement">
              <i class="el-icon-trophy"></i>
              <span>{{ achievement }}</span>
            </div>
          </div>
        </section>

        <!-- 专业领域 -->
        <section class="expert-specialties">
          <h2>专业领域</h2>
          <div class="specialties-grid">
            <div class="specialty-item" v-for="specialty in expert.specialties_detail" :key="specialty.name">
              <div class="specialty-icon">{{ specialty.icon }}</div>
              <h3>{{ specialty.name }}</h3>
              <p>{{ specialty.description }}</p>
            </div>
          </div>
        </section>

        <!-- 教育背景 -->
        <section class="expert-education">
          <h2>教育背景</h2>
          <div class="education-timeline">
            <div class="education-item" v-for="edu in expert.education" :key="edu.year">
              <div class="edu-year">{{ edu.year }}</div>
              <div class="edu-content">
                <h3>{{ edu.degree }}</h3>
                <p>{{ edu.school }}</p>
                <p>{{ edu.description }}</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 工作经历 -->
        <section class="expert-experience">
          <h2>工作经历</h2>
          <div class="experience-timeline">
            <div class="experience-item" v-for="exp in expert.experience" :key="exp.period">
              <div class="exp-period">{{ exp.period }}</div>
              <div class="exp-content">
                <h3>{{ exp.position }}</h3>
                <p>{{ exp.organization }}</p>
                <p>{{ exp.description }}</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 学术成果 -->
        <section class="expert-academic">
          <h2>学术成果</h2>
          <div class="academic-content">
            <div class="academic-section">
              <h3>发表论文</h3>
              <ul class="paper-list">
                <li v-for="paper in expert.papers" :key="paper.title">{{ paper.title }} - {{ paper.journal }} ({{ paper.year }})</li>
              </ul>
            </div>
            <div class="academic-section">
              <h3>出版著作</h3>
              <ul class="book-list">
                <li v-for="book in expert.books" :key="book.title">{{ book.title }} - {{ book.publisher }} ({{ book.year }})</li>
              </ul>
            </div>
          </div>
        </section>

        <!-- 服务案例 -->
        <section class="expert-cases">
          <h2>服务案例</h2>
          <div class="cases-grid">
            <div class="case-card" v-for="case_item in expert.cases" :key="case_item.id">
              <div class="case-header">
                <h3>{{ case_item.title }}</h3>
                <span class="case-type">{{ case_item.type }}</span>
              </div>
              <p class="case-description">{{ case_item.description }}</p>
              <div class="case-result">
                <strong>服务效果：</strong>{{ case_item.result }}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- 预约表单弹窗 -->
    <div class="booking-modal" v-if="showBookingForm" @click.self="showBookingForm = false">
      <div class="booking-modal-content">
        <div class="modal-header">
          <h3>预约 {{ expert.name }} 专家咨询</h3>
          <button @click="showBookingForm = false" class="close-btn">&times;</button>
        </div>
        <form @submit.prevent="submitBooking" class="booking-form">
          <div class="form-group">
            <label>姓名</label>
            <input type="text" v-model="bookingForm.name" placeholder="请输入您的姓名" required>
          </div>
          <div class="form-group">
            <label>电话</label>
            <input type="tel" v-model="bookingForm.phone" placeholder="请输入您的电话" required>
          </div>
          <div class="form-group">
            <label>咨询类型</label>
            <select v-model="bookingForm.type" required>
              <option value="">请选择咨询类型</option>
              <option value="health">健康检测</option>
              <option value="management">健康管理</option>
              <option value="consultation">专家咨询</option>
              <option value="conditioning">健康调理</option>
            </select>
          </div>
          <div class="form-group">
            <label>预约时间</label>
            <input type="datetime-local" v-model="bookingForm.datetime" required>
          </div>
          <div class="form-group">
            <label>问题描述</label>
            <textarea v-model="bookingForm.description" placeholder="请简要描述您的健康问题或咨询需求" rows="4"></textarea>
          </div>
          <div class="form-actions">
            <button type="button" @click="showBookingForm = false" class="btn-cancel">取消</button>
            <button type="submit" class="btn-submit">提交预约</button>
          </div>
        </form>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'ExpertProfile',
  data() {
    return {
      expert: null,
      showBookingForm: false,
      phone: '',
      login: false,
      bookingForm: {
        name: '',
        phone: '',
        type: '',
        datetime: '',
        description: ''
      },
      experts: {
        1: {
          id: 1,
          name: '张明华',
          avatar: '👨‍⚕️',
          title: '首席健康专家',
          specialty: '量子健康检测、慢性病管理',
          tags: ['首席专家', '20年经验', '国家科技进步奖'],
          bio: '从事健康管理工作20余年，在量子健康检测技术领域有深厚造诣。曾主持多项国家级健康科研项目，发表学术论文50余篇。擅长慢性病早期筛查和个性化健康管理方案制定。',
          achievements: [
            '国家科技进步奖获得者',
            '中华医学会健康管理学分会委员',
            '量子健康检测技术标准制定专家组成员',
            '健康管理师职业资格认证专家'
          ],
          specialties_detail: [
            {
              name: '量子健康检测',
              icon: '🔬',
              description: '运用先进量子检测设备，全面评估身体健康状况'
            },
            {
              name: '慢性病管理',
              icon: '🏥',
              description: '为高血压、糖尿病等慢性病患者提供个性化管理方案'
            },
            {
              name: '健康风险评估',
              icon: '📊',
              description: '基于大数据分析，预测潜在健康风险'
            }
          ],
          education: [
            {
              year: '1995-2000',
              degree: '医学博士',
              school: '北京协和医学院',
              description: '内科学专业，研究方向为慢性病预防与控制'
            },
            {
              year: '1990-1995',
              degree: '医学学士',
              school: '同济医科大学',
              description: '临床医学专业，成绩优异'
            }
          ],
          experience: [
            {
              period: '2010-至今',
              position: '首席健康专家',
              organization: '北京和合网链科技有限公司',
              description: '负责健康管理技术研发和团队建设'
            },
            {
              period: '2005-2010',
              position: '健康管理中心主任',
              organization: '北京301医院',
              description: '负责健康管理中心运营和慢性病管理工作'
            }
          ],
          papers: [
            { title: '量子检测技术在慢性病早期筛查中的应用研究', journal: '中华健康管理学杂志', year: '2022' },
            { title: '个性化健康管理方案的制定与效果评估', journal: '中国慢性病预防与控制', year: '2021' }
          ],
          books: [
            { title: '量子健康检测技术与应用', publisher: '人民卫生出版社', year: '2020' },
            { title: '慢性病健康管理实践指南', publisher: '科学出版社', year: '2019' }
          ],
          cases: [
            {
              id: 1,
              title: '高血压早期干预案例',
              type: '慢性病管理',
              description: '通过量子检测发现早期高血压风险，制定个性化干预方案',
              result: '3个月内血压恢复正常，避免了药物依赖'
            },
            {
              id: 2,
              title: '糖尿病并发症预防案例',
              type: '健康管理',
              description: '为糖尿病患者制定综合管理方案，预防并发症发生',
              result: '血糖控制稳定，生活质量显著提高'
            }
          ]
        },
        2: {
          id: 2,
          name: '李晓芳',
          avatar: '👩‍⚕️',
          title: '营养学专家',
          specialty: '临床营养、功能性营养干预',
          tags: ['营养学博士', '15年经验', '功能性营养专家'],
          bio: '营养学博士，专注于功能性营养和精准营养研究。在肥胖管理、糖尿病营养干预、抗衰老营养等领域有丰富经验。为数千名客户制定个性化营养方案。',
          achievements: [
            '中国营养学会理事',
            '功能性食品研发专家',
            '国际营养师联盟认证专家',
            '营养学教材编委'
          ],
          specialties_detail: [
            {
              name: '体重管理',
              icon: '⚖️',
              description: '科学减重，健康塑形，制定个性化营养方案'
            },
            {
              name: '糖尿病营养',
              icon: '🩺',
              description: '为糖尿病患者提供专业的营养指导和饮食方案'
            },
            {
              name: '抗衰老营养',
              icon: '🌟',
              description: '通过营养干预延缓衰老，提升生命质量'
            }
          ],
          education: [
            {
              year: '2005-2010',
              degree: '营养学博士',
              school: '中国农业大学',
              description: '功能性食品与营养保健方向'
            }
          ],
          experience: [
            {
              period: '2015-至今',
              position: '营养学专家',
              organization: '北京和合网链科技有限公司',
              description: '负责营养方案制定和功能性营养研究'
            }
          ],
          papers: [
            { title: '功能性营养在体重管理中的应用', journal: '营养学报', year: '2021' }
          ],
          books: [
            { title: '功能性营养学', publisher: '中国轻工业出版社', year: '2020' }
          ],
          cases: [
            {
              id: 1,
              title: '肥胖症营养干预案例',
              type: '体重管理',
              description: '为肥胖客户制定个性化营养方案',
              result: '6个月减重15公斤，各项指标恢复正常'
            }
          ]
        },
        3: {
          id: 3,
          name: '王建国',
          avatar: '👨‍⚕️',
          title: '运动康复专家',
          specialty: '运动医学、康复治疗',
          tags: ['运动医学硕士', '前国家队队医', '康复专家'],
          bio: '运动医学硕士，前国家队队医。在运动损伤预防、康复治疗、运动处方制定等方面有丰富经验。擅长结合现代康复技术为客户提供科学的运动指导。',
          achievements: [
            '奥运会医疗保障专家',
            '中国康复医学会会员',
            '运动处方师认证导师',
            '康复治疗技术标准制定专家'
          ],
          specialties_detail: [
            {
              name: '运动损伤康复',
              icon: '🏃‍♂️',
              description: '专业治疗各种运动损伤，制定康复训练计划'
            },
            {
              name: '运动处方制定',
              icon: '📋',
              description: '根据个人情况制定科学的运动处方'
            },
            {
              name: '功能恢复训练',
              icon: '💪',
              description: '帮助患者恢复身体功能，提高生活质量'
            }
          ],
          education: [
            {
              year: '2000-2005',
              degree: '运动医学硕士',
              school: '北京体育大学',
              description: '运动康复与理疗学方向'
            }
          ],
          experience: [
            {
              period: '2012-至今',
              position: '运动康复专家',
              organization: '北京和合网链科技有限公司',
              description: '负责运动康复技术研发和临床应用'
            }
          ],
          papers: [
            { title: '现代康复技术在运动损伤治疗中的应用', journal: '中国运动医学杂志', year: '2021' }
          ],
          books: [
            { title: '运动康复学理论与实践', publisher: '人民体育出版社', year: '2019' }
          ],
          cases: [
            {
              id: 1,
              title: '膝关节损伤康复案例',
              type: '运动康复',
              description: '为膝关节损伤患者制定康复方案',
              result: '3个月恢复功能，重返运动场'
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.loadExpert()
  },
  watch: {
    '$route.query.id'(e) {
      if(e){
        this.loadExpert()
      }
    }
  },
  methods: {
    openShowBookingForm(){
      // this.showBookingForm = true;
      this.$router.push({
        path: '/',
        query: { type: 'appointment' }
      })
    },
    loadExpert() {
      const serviceId = this.$route.query.id
      this.expert = this.experts[serviceId]
      
      if (!this.expert) {
        // 不再强制跳转，而是显示错误信息或使用默认服务
        console.warn(`未找到ID为 ${serviceId} 的服务，将显示默认服务`)
        // 使用第一个服务作为默认服务
        const serviceIds = Object.keys(this.experts)
        if (serviceIds.length > 0) {
          this.expert = this.experts[serviceIds[0]]
          // 更新URL但不触发路由变化
          this.$router.replace({ query: { id: serviceIds[0] } })
        }
        return
      }
      
      // 获取相关服务
      this.relatedServices = Object.values(this.experts)
        .filter(s => s.id !== parseInt(serviceId))
        .slice(0, 3)
    },
    shareProfile() {
      // 实现分享功能
      if (navigator.share) {
        navigator.share({
          title: `${this.expert.name} - ${this.expert.title}`,
          text: this.expert.bio,
          url: window.location.href
        })
      } else {
        // 复制链接到剪贴板
        navigator.clipboard.writeText(window.location.href)
        this.$message.success('链接已复制到剪贴板')
      }
    },
    submitBooking() {
      // 处理预约提交
      console.log('提交预约:', this.bookingForm)
      this.$message.success('预约提交成功！我们会尽快与您联系。')
      this.showBookingForm = false
      // 重置表单
      this.bookingForm = {
        name: '',
        phone: '',
        type: '',
        datetime: '',
        description: ''
      }
    },
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('检测结果功能')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.breadcrumb {
  background: white;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.breadcrumb .container {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding-left: 10px;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb a:hover {
  color: #1890ff;
}

.separator {
  color: #999;
}

.current {
  color: #1890ff;
}

.expert-detail-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.expert-header {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  gap: 40px;
  align-items: start;
  margin-bottom: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e9ecef;
}

.expert-avatar-large {
  text-align: center;
}

.avatar-circle {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(24, 144, 255, 0.3);
}

.expert-basic-info h1 {
  font-size: 36px;
  margin-bottom: 10px;
  color: #333;
}

.expert-title {
  font-size: 20px;
  color: #1890FF;
  margin-bottom: 10px;
  font-weight: 600;
}

.expert-specialty {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.expert-tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.tag {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.expert-actions {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(24, 144, 255, 0.3);
}

.btn-secondary {
  background: white;
  color: #1890FF;
  border: 2px solid #1890FF;
  padding: 10px 22px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: #1890FF;
  color: white;
}

section {
  margin-bottom: 60px;
}

section h2 {
  font-size: 28px;
  margin-bottom: 30px;
  color: #333;
  font-weight: 600;
}

.intro-content p {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
}

.achievements-list {
  display: grid;
  gap: 20px;
}

.achievement-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #1890FF;
}

.achievement-item i {
  color: #1890FF;
  font-size: 20px;
}

.specialties-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.specialty-item {
  text-align: center;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
}

.specialty-item:hover {
  transform: translateY(-5px);
}

.specialty-icon {
  font-size: 40px;
  margin-bottom: 20px;
}

.specialty-item h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.specialty-item p {
  color: #666;
  line-height: 1.6;
}

.education-timeline,
.experience-timeline {
  position: relative;
  padding-left: 30px;
}

.education-item,
.experience-item {
  position: relative;
  padding-bottom: 30px;
  border-left: 2px solid #e9ecef;
  padding-left: 30px;
}

.education-item::before,
.experience-item::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 0;
  width: 14px;
  height: 14px;
  background: #1890FF;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 3px #e3f2fd;
}

.edu-year,
.exp-period {
  font-weight: 600;
  color: #1890FF;
  margin-bottom: 10px;
}

.edu-content h3,
.exp-content h3 {
  font-size: 18px;
  margin-bottom: 5px;
  color: #333;
}

.edu-content p,
.exp-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 5px;
}

.academic-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.academic-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #333;
}

.paper-list,
.book-list {
  list-style: none;
  padding: 0;
}

.paper-list li,
.book-list li {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
  line-height: 1.6;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.case-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.case-header h3 {
  font-size: 18px;
  margin: 0;
  color: #333;
}

.case-type {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.case-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.case-result {
  color: #28a745;
  font-weight: 500;
}

/* 预约表单弹窗样式 */
.booking-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.booking-modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  animation: slideUp 0.3s ease-out;
  border: 1px solid rgba(255,255,255,0.2);
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  border-radius: 20px 20px 0 0;
  position: relative;
}

.modal-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.modal-header h3 {
  margin: 0;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.close-btn {
  background: rgba(255,255,255,0.2);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.close-btn:hover {
  background: rgba(255,255,255,0.3);
  transform: rotate(90deg);
}

.booking-form {
  padding: 40px 30px;
  background: white;
  border-radius: 0 0 20px 20px;
}

.form-group {
  margin-bottom: 25px;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.95rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e1e8ed;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3498db;
  background: white;
  box-shadow: 0 0 0 4px rgba(52, 152, 219, 0.1);
  transform: translateY(-2px);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.form-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.btn-cancel {
  flex: 1;
  padding: 15px 30px;
  border: 2px solid #e1e8ed;
  background: white;
  color: #6c757d;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
  transform: translateY(-2px);
}

.btn-submit {
  flex: 2;
  padding: 15px 30px;
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn-submit::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.btn-submit:hover::before {
  left: 100%;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(52, 152, 219, 0.3);
}

/* 底部样式 */
.footer {
  background: #2c3e50;
  color: white;
  padding: 50px 0 20px;
}

.footer .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 40px;
  margin-bottom: 30px;
}

.footer-info h3 {
  font-size: 20px;
  margin-bottom: 15px;
}

.footer-info p {
  margin-bottom: 20px;
  opacity: 0.8;
}

.contact-info p {
  margin-bottom: 10px;
  opacity: 0.8;
}

.footer-links-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.footer-links h4,
.footer-services h4,
.footer-social h4 {
  font-size: 16px;
  margin-bottom: 15px;
}

.footer-links a,
.footer-services a {
  display: block;
  color: white;
  text-decoration: none;
  margin-bottom: 10px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.footer-links a:hover,
.footer-services a:hover {
  opacity: 1;
}

.social-icon {
  display: block;
  color: white;
  text-decoration: none;
  margin-bottom: 10px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.social-icon:hover {
  opacity: 1;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.copyright p {
  opacity: 0.6;
  font-size: 14px;
}

@media (max-width: 768px) {
  .expert-header {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 30px;
  }
  
  .expert-actions {
    flex-direction: row;
    justify-content: center;
  }
  
  .academic-content {
    grid-template-columns: 1fr;
  }
  
  .specialties-grid {
    grid-template-columns: 1fr;
  }
  
  .cases-grid {
    grid-template-columns: 1fr;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
  }
  
  .footer-links-group {
    grid-template-columns: 1fr;
  }
}
</style>